export default __webpack_public_path__ + "static/media/Licenses_IMG-QA-02.a3f63130.png";